export default {
  namespaced: true,
  state: {
    conversationProfile: {},
    isSendMessage: false,
    conversationId: '',
    currentMessageList: [],
    nextReqMessageID: '',
    isCompleted: false
  },
  mutations: {
    setConversationProfile(state, info) {
      state.conversationProfile = info
    },
    setIsCompleted(state, flag) {
      state.isCompleted = flag
    },
    setNextReqMessageID(state, flag) {
      state.nextReqMessageID = flag
    },
    pushList(state, message) {
      // 录入消息
      if (!state.currentMessageList) {
        state.currentMessageList = []
      }
      const msg = Array.isArray(message) ? message : [message]
      // state.currentMessageList.push(...msg)
      state.currentMessageList.unshift(...msg.reverse())
    },
    unshiftList(state, list = []) {
      // 下拉加载使用
      // state.currentMessageList.unshift(...list)
      state.currentMessageList = [...state.currentMessageList, ...list.reverse()]
    },
    resetList(state) {
      // 重置列表
      state.isCompleted = ''
      state.nextReqMessageID = ''
      state.currentMessageList = []
    },
    removeMessage(state, message) {
      // 删除消息、撤回消息
      if (!state.currentMessageList) {
        return
      }
      const index = state.currentMessageList.findIndex(({ ID }) => ID === message.ID)
      if (~index) {
        state.currentMessageList.splice(index, 1, message)
      }
    },
    setConversationId(state, id) {
      state.conversationId = id
    },
    setLastMessage(state, flag) {
      state.isSendMessage = flag
    }
  }
}
